import apiHelpers from './apiHelpers';

export default {
    getUrls() {
        return apiHelpers.httpRequest('link/clicks', {}, 'get');
    },
    addClicks(body) {
        return apiHelpers.httpRequest('link/clicks', body, 'post');
    },
    deleteUrlPages(id) {
        return apiHelpers.httpRequest(`link/clicks/${id}`, {}, 'delete');
    },
    getDomains(){
        return apiHelpers.httpRequest('link/domains', {}, 'get');
    }
};